import React from "react";
import CustomMarkdown from "core/components/global/markdown/markdown";
import { Message, MessageListProps } from "./types";

// Individual message component to prevent unnecessary re-renders
const MessageItem = React.memo(({ 
  message, 
  theme 
}: { 
  message: Message;
  theme: any;
}) => {
  // Check if this is an empty AI message (waiting for content)
  const isEmptyAiMessage = message.type === 'ai' && message.content === '';
  
  return (
    <div
      key={message.id}
      className={`p-3 my-2 rounded-lg shadow w-75 ${
        message.type === 'user'
          ? `ml-auto ${theme.name === "dark-theme" ? "bg-[#212121] text-white" : "bg-purple-100 text-black"}`
          : `mr-auto ${theme.name === "dark-theme" ? "bg-gray-600 text-white" : "bg-purple-100 text-black"}`
      } ${isEmptyAiMessage ? 'animate-pulse' : ''}`}
    >
      {isEmptyAiMessage ? (
        // Skeleton loader for empty AI message
        <>
          <div className={`h-4 ${theme.name === "dark-theme" ? "bg-gray-500" : "bg-gray-300"} rounded w-3/4 mb-2`}></div>
          <div className={`h-4 ${theme.name === "dark-theme" ? "bg-gray-500" : "bg-gray-300"} rounded w-1/2 mb-2`}></div>
          <div className={`h-4 ${theme.name === "dark-theme" ? "bg-gray-500" : "bg-gray-300"} rounded w-2/3 mb-2`}></div>
          
          {/* Date/time skeleton */}
          <div className="flex justify-end mt-1">
            <div className={`h-3 ${theme.name === "dark-theme" ? "bg-gray-500" : "bg-gray-300"} rounded w-16`}></div>
          </div>
        </>
      ) : typeof message.content === "string" ? (
        <>
          <p className="text-sm">
            <CustomMarkdown
              content={message.content}
              showEditButton={false}
            />
          </p>
          <div className="text-xs text-gray-500 mt-1 text-right">
            {new Date(message.timestamp).toLocaleTimeString()}
          </div>
        </>
      ) : (
        <>
          <p className="text-sm">{JSON.stringify(message.content)}</p>
          <div className="text-xs text-gray-500 mt-1 text-right">
            {new Date(message.timestamp).toLocaleTimeString()}
          </div>
        </>
      )}
    </div>
  );
});


const MessageList: React.FC<MessageListProps> = ({ 
  messages, 
  isLoading, 
  theme,
  messagesEndRef
}) => {
  return (
    <div className="transition-column mt-3 ml-[5.5rem] me-3 col-md-10 messages d-flex flex-column h-full overflow-auto flex-grow gap-[1.5rem]">
      {messages.map((message) => (
        <MessageItem key={message.id} message={message} theme={theme} />
      ))}
      
      <div ref={messagesEndRef} />
    </div>
  );
};

export default React.memo(MessageList);